module.exports = __webpack_public_path__ + "img/banner-covid19.d3b3128d.jpg";